/**
 * Высокоуровневое применение SEO и AEO-разметки на страницах
 */

import { SITE_URL } from '@/config'
import {
  META_DESCRIPTIONS,
  PAGE_TITLES,
  NOINDEX_ROUTE_NAMES,
  DEFAULT_OG_IMAGE_PATH
} from '@/constants/seo'
import {
  setPageTitle,
  setMetaDescription,
  setRobots,
  setCanonical,
  setOpenGraph,
  setTwitterCard,
  setJsonLd,
  clearJsonLd,
  truncateDescription
} from '@/utils/seoUtils'

export { buildAbsoluteUrl } from '@/utils/structuredData'
import { buildAbsoluteUrl } from '@/utils/structuredData'

export function buildOgImageUrl(imagePath) {
  const origin = SITE_URL.replace(/\/$/, '')
  const path = imagePath || DEFAULT_OG_IMAGE_PATH
  return `${origin}${path.startsWith('/') ? path : `/${path}`}`
}

/**
 * @param {{
 *   title?: string,
 *   description?: string,
 *   path?: string,
 *   image?: string | null,
 *   type?: string,
 *   robots?: string | null,
 *   jsonLd?: object | object[] | null
 * }} options
 */
export function applyPageSeo(options = {}) {
  const {
    title,
    description = '',
    path = typeof window !== 'undefined' ? window.location.pathname : '/',
    image = null,
    type = 'website',
    robots = null,
    jsonLd = null
  } = options

  const safeDescription = truncateDescription(description)
  const canonicalUrl = buildAbsoluteUrl(path)
  const ogImage = image || buildOgImageUrl()

  if (title) {
    setPageTitle(title)
  }

  if (safeDescription) {
    setMetaDescription(safeDescription)
  }

  setCanonical(canonicalUrl)
  setRobots(robots)

  const documentTitle = document.title
  setOpenGraph({
    title: documentTitle,
    description: safeDescription,
    image: ogImage,
    url: canonicalUrl,
    type
  })
  setTwitterCard({
    title: documentTitle,
    description: safeDescription,
    image: ogImage
  })

  clearJsonLd()
  if (jsonLd) {
    setJsonLd(jsonLd)
  }
}

export function applyRouteSeo(route) {
  const routeName = route.name
  if (!routeName) return

  const title = PAGE_TITLES[routeName]
  const description = META_DESCRIPTIONS[routeName]
  const robots = NOINDEX_ROUTE_NAMES.has(routeName) ? 'noindex, nofollow' : null

  if (!title && !description && !robots) return

  applyPageSeo({
    title: title || undefined,
    description: description || '',
    path: route.fullPath.split('?')[0] || '/',
    robots
  })
}
